import { InferenceSetup } from "./setup";
import { logger } from "./utils/logger";

async function main() {
  InferenceSetup.initialise();
}

export function safeMain() {
  try {
    main();
  } catch (e) {
    logger({ EntireScriptErrored: e });
  }
}
